import { expImage1, expImage2, expImage3, expImage4 } from "@/mocks/images";
import { experience } from "@/mocks/site-data";
import Reveal from "@/components/feature/Reveal";

const galleryImages = [
  { src: expImage1, alt: "Detalhe do ambiente do consultório" },
  { src: expImage2, alt: "Consultório da Dra. Sâmia Albuquerque" },
  { src: expImage3, alt: "Lifestyle — beleza natural e elegância" },
  { src: expImage4, alt: "Dra. Sâmia Albuquerque — sobre" },
];

export default function Experience() {
  return (
    <section className="bg-background-100/80 py-20 md:py-28">
      <div className="mx-auto max-w-8xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
              Experiência e ambiente
            </p>
            <h2 className="mt-3 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-4xl">
              {experience.title}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-400">{experience.text}</p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {galleryImages.map((img, i) => (
            <Reveal key={img.alt} delay={i * 100} className={i % 2 === 0 ? "lg:mt-10" : ""}>
              <img
                src={img.src}
                alt={img.alt}
                title={img.alt}
                className="w-full rounded-lg border border-accent-400/30 object-cover object-top aspect-[3/4]"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}